const api = require("../../../../config/api");
const axios = require("axios");
const service = require("../../../../services/statistics");
const { get } = require("lodash");

// console.log("api---", api);
$(function () {
  const md5 = require("md5");
  $(".login3-left div").click(function () {
    // 链式编程操作
    $(this).addClass("active").siblings().removeClass("active");
    //点击的同时，得到当前元素的索引号
    let index = $(this).index();
    //里面相应索引号的内容显示，其余的内容隐藏
    $(".login3-right .right").eq(index).show().siblings().hide();
  });

  // 三个系统
  $(".login2New-top .left").click(function () {
    // 链式编程操作
    $(this).addClass("active").siblings().removeClass("active");
    //点击的同时，得到当前元素的索引号
    let index = $(this).index();
    //里面相应索引号的内容显示，其余的内容隐藏
    $(".login2New-bottom .right").eq(index).show().siblings().hide();
    $(".login2New-bottom .loginPrev").css("display", "block");
    $(".login2New-bottom .loginNext").css("display", "none");
  });

  // 区块链官网
  $(".login2New-bottom .loginBtn1").click(async function () {
    const tel1 = $(".name1").val();
    const pass1 = $(".password1").val();
    const reg0 = /^1[3|4|5|6|7|8|9]\d{9}$/;
    if (!reg0.test(tel1)) {
      // return alert("请输入正确的手机号");
      return toastr.info("请输入正确的手机号");
    }
    let reg = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}");
    // if (!reg.test(pass1)) {
    //   return alert("密码为8-16位，且必须包含数字和字母");
    // }
    if (!tel1 || !pass1) {
      // alert("请输入账号及密码");
      toastr.info("请输入账号及密码");
    } else {
      let token = "";
      let sysId = "";
      let orgList = [];
      let obj = {
        account: tel1,
        password: md5(pass1),
      };
      const res = await axios.post(api.common.statistics.qk_login, obj);
      if (res.data.state == 200) {
        token = res.data.results.token;
        $(".login2New-bottom .loginNext").css("display", "block");
        $(".login2New-bottom .loginPrev").css("display", "none");
      } else {
        // return alert(res.msg);
        return toastr.error(res.msg);
      }
      const res1 = await axios.get(
        `${api.common.statistics.sysUrl}?sysUrl=http://main.jgwcjm.com`
      );
      if (res1.data.state == 200) {
        sysId = res1.data.results.sysId;
      }
      const res2 = await axios.get(
        `${api.common.statistics.orgList}?sysId=${sysId}`,
        {
          headers: {
            "super-token": token,
          },
        }
      );
      if (res2.data.state == 200) {
        orgList = res2.data.results.list;
        var optionName = "";
        orgList.forEach((item) => {
          optionName += `<option value=${item.organizationId}> ${item.organizationName} </option>`;
        });
        $("#blockSelect").html(optionName);
        $("#blockSelect").change(function () {
          // 选中的value值
          let value = $(this).val();
          $(".loginBtn1New").click(function () {
            window.open(
              `http://main.jgwcjm.com/?site=public&u=${tel1}&p=${md5(
                pass1
              )}&s=${sysId}&o=${value}`
            );
          });
        });
        $(".loginBtn1New").click(function () {
          window.open(
            `http://main.jgwcjm.com/?site=public&u=${tel1}&p=${md5(
              pass1
            )}&s=${sysId}&o=${$("#blockSelect option:selected").val()}`
          );
        });
      }
    }
  });

  // 超级码云
  $(".login2New-bottom .loginBtn2").click(async function () {
    const tel2 = $(".name2").val();
    const pass2 = $(".password2").val();
    const reg0 = /^1[3|4|5|6|7|8|9]\d{9}$/;
    if (!reg0.test(tel2)) {
      // return alert("请输入正确的手机号");
      return toastr.info("请输入正确的手机号");
    }
    // let reg = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}");
    // if (!reg.test(pass2)) {
    //   return alert("密码为8-16位，且必须包含数字和字母");
    // }
    if (!tel2 || !pass2) {
      // alert("请输入账号及密码");
      toastr.info("请输入账号及密码");
    } else {
      let token = "";
      let sysId = "";
      let orgList = [];
      let obj = {
        account: tel2,
        password: md5(pass2),
      };
      const res = await axios.post(api.common.statistics.clound_login, obj);
      if (res.data.state == 200) {
        token = res.data.results.token;
        $(".login2New-bottom .loginNext").css("display", "block");
        $(".login2New-bottom .loginPrev").css("display", "none");
      } else {
        // return alert(res.msg);
        return toastr.error(res.msg);
      }
      const res1 = await axios.get(
        `${api.common.statistics.clound_sysUrl}?sysUrl=http://packaging.jgwcjm.com`
      );
      if (res1.data.state == 200) {
        sysId = res1.data.results.sysId;
      }
      const res2 = await axios.get(
        `${api.common.statistics.clound_orgList}?sysId=${sysId}`,
        {
          headers: {
            "super-token": token,
          },
        }
      );
      if (res2.data.state == 200) {
        orgList = res2.data.results.list;
        var optionName = "";
        orgList.forEach((item) => {
          optionName += `<option value=${item.organizationId}> ${item.organizationName} </option>`;
        });
        $("#blockSelect2").html(optionName);
        $("#blockSelect2").change(function () {
          // 选中的value值
          let value = $(this).val();
          $(".loginBtn2New").click(function () {
            window.open(
              `http://packaging.jgwcjm.com/?site=public&u=${tel2}&p=${md5(
                pass2
              )}&s=${sysId}&o=${value}`
            );
          });
        });
        $(".loginBtn2New").click(function () {
          window.open(
            `http://packaging.jgwcjm.com/?site=public&u=${tel2}&p=${md5(
              pass2
            )}&s=${sysId}&o=${$("#blockSelect2 option:selected").val()}`
          );
        });
      }
    }
  });

  // iot
  $(".login2New-bottom .loginBtn3").click(async function () {
    const tel3 = $(".name3").val();
    const pass3 = $(".password3").val();
    const reg0 = /^1[3|4|5|6|7|8|9]\d{9}$/;
    if (!reg0.test(tel3)) {
      // return alert("请输入正确的手机号");
      return toastr.info("请输入正确的手机号");
    }
    // let reg = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}");
    // if (!reg.test(pass2)) {
    //   return alert("密码为8-16位，且必须包含数字和字母");
    // }
    if (!tel3 || !pass3) {
      // alert("请输入账号及密码");
      toastr.info("请输入账号及密码");
    } else {
      // let obj = {
      //   account: tel3,
      //   password: md5(pass3),
      // };
      // // 获取区块登记
      // fetch(api.common.statistics.clound_login, {
      //   method: "post",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(obj),
      // })
      //   .then((response) => response.json())
      //   .then((res) => {
      //     if (res.state == 200) {
      //       $(".login2New-bottom .loginNext").css("display", "block");
      //       $(".login2New-bottom .loginPrev").css("display", "none");
      //       // 获取sysId
      //       fetch(
      //         api.common.statistics.clound_sysUrl +
      //           "?" +
      //           `sysUrl=http://ywiot.jgwcjm.com`,
      //         {
      //           method: "get",
      //         }
      //       )
      //         .then((response) => response.json())
      //         .then((res1) => {
      //           if (res1.state == 200) {
      //             // 获取组织
      //             let orgList = [];
      //             fetch(
      //               api.common.statistics.clound_orgList +
      //                 "?" +
      //                 `sysId=${res1.results.sysId}`,

      //               {
      //                 method: "get",
      //                 headers: {
      //                   "super-token": res.results.token,
      //                 },
      //               }
      //             )
      //               .then((response) => response.json())
      //               .then((res2) => {
      //                 if (res2.state == 200) {
      //                   orgList = res2.results.list;
      //                   var option = "";
      //                   orgList.forEach((item) => {
      //                     option += `<option value=${item.organizationId}> ${item.organizationName} </option>`;
      //                   });
      //                   $("#blockSelect3").html(option);
      //                   $("#blockSelect3").change(function () {
      //                     // 选中的value值
      //                     let value = $(this).val();
      //                     $(".loginBtn3New").click(function () {
      //                       window.open(
      //                         `http://ywiot.jgwcjm.com/?site=public&u=${tel3}&p=${md5(
      //                           pass3
      //                         )}&s=${res1.results.sysId}&o=${value}`
      //                       );
      //                     });
      //                   });
      //                   $(".loginBtn3New").click(function () {
      //                     window.open(
      //                       `http://ywiot.jgwcjm.com/?site=public&u=${tel3}&p=${md5(
      //                         pass3
      //                       )}&s=${res1.results.sysId}&o=${$(
      //                         "#blockSelect3 option:selected"
      //                       ).val()}`
      //                     );
      //                   });
      //                 }
      //               });
      //           }
      //         });
      //     } else {
      //       return alert(res.msg);
      //     }
      //   });

      let token = "";
      let sysId = "";
      let orgList = [];
      let obj = {
        account: tel3,
        password: md5(pass3),
      };
      const res = await axios.post(api.common.statistics.clound_login, obj);
      if (res.data.state == 200) {
        token = res.data.results.token;
        $(".login2New-bottom .loginNext").css("display", "block");
        $(".login2New-bottom .loginPrev").css("display", "none");
      } else {
        // return alert(res.msg);
        return toastr.error(res.msg);
      }
      const res1 = await axios.get(
        `${api.common.statistics.clound_sysUrl}?sysUrl=http://ywiot.jgwcjm.com`
      );
      if (res1.data.state == 200) {
        sysId = res1.data.results.sysId;
      }
      const res2 = await axios.get(
        `${api.common.statistics.clound_orgList}?sysId=${sysId}`,
        {
          headers: {
            "super-token": token,
          },
        }
      );
      if (res2.data.state == 200) {
        orgList = res2.data.results.list;
        var optionName = "";
        orgList.forEach((item) => {
          optionName += `<option value=${item.organizationId}> ${item.organizationName} </option>`;
        });
        $("#blockSelect3").html(optionName);
        $("#blockSelect3").change(function () {
          // 选中的value值
          let value = $(this).val();
          $(".loginBtn3New").click(function () {
            window.open(
              `http://ywiot.jgwcjm.com/?site=public&u=${tel3}&p=${md5(
                pass3
              )}&s=${sysId}&o=${value}`
            );
          });
        });
        $(".loginBtn3New").click(function () {
          window.open(
            `http://ywiot.jgwcjm.com/?site=public&u=${tel3}&p=${md5(
              pass3
            )}&s=${sysId}&o=${$("#blockSelect3 option:selected").val()}`
          );
        });
      }
    }
  });

  // 区块链产品防伪查询中心
  // 区块号
  $(".login1 .login3-right .login3-search1").click(function () {
    const chainCode1 = $(".chain1").val();
    let reg = /^(\d{7})$/;
    if (!reg.test(chainCode1) || !chainCode1) {
      // alert("请输入7位区块号");
      toastr.info("请输入7位区块号");
    } else {
      window.open(
        `http://www.jointchain.net/blockDetail?searchType=1&searchContent=${chainCode1}&channelName=evidencechannel`
      );
    }
  });

  // 区块哈希
  $(".login1 .login3-right .login3-search2").click(function () {
    const chainCode2 = $(".chain2").val();
    // let reg1 = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[^]{64}$/;
    let reg1 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{64}$/;
    if (!reg1.test(chainCode2) || !chainCode2 || chainCode2.length > 64) {
      // alert("请输入64位数字+字母的区块哈希");
      toastr.info("请输入64位数字+字母的区块哈希");
    } else {
      window.open(
        `http://www.jointchain.net/blockDetail?searchType=2&searchContent=${chainCode2}&channelName=evidencechannel`
      );
    }
  });

  // 交易哈希
  $(".login1 .login3-right .login3-search3").click(function () {
    const chainCode3 = $(".chain3").val();
    // let reg3 = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[^]{64}$/;
    let reg3 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{64}$/;
    if (!reg3.test(chainCode3) || !chainCode3 || chainCode3.length > 64) {
      // alert("请输入64位数字+字母的交易哈希");
      toastr.info("请输入64位数字+字母的交易哈希");
    } else {
      window.open(
        `http://www.jointchain.net/informationDetail?channelName=evidencechannel&search=${chainCode3}`
      );
    }
  });
});

$(async function () {
  // 真伪查询跳转
  let queryCode = window.location.search;
  var n1 = queryCode.length; //地址的总长度
  var n2 = queryCode.indexOf("="); //取得=号的位置
  var codeHref = queryCode.substr(n2 + 1, n1 - n2); //从=号后面的内容
  if (codeHref) {
    const res = await axios.get(`${api.common.checkout}?fakeCode=${codeHref}`);
    if (res.data.state == 200) {
      let c = res.data.results[0];
      var el = `<div class="popup-wrap">
  <div class="popup-box">
  <div class="popup-close"></div>
  <div class="popup-content">
    <div class="popup-head">
      <div class="popup-head-num">${c.flickCount}</div>
      <div class="popup-head-text">${c.prompt}</div>
    </div>
    <div class="popup-detail">
      <div class="popup-detail-left">
        <div class="left-item">
          <div class="left-name">产品身份编码:</div>
          <div class="left-answer">${c.productDetail.fakeCode}</div>
        </div>
        <div class="left-item">
          <div class="left-name">当前查询次数:</div>
          <div class="left-answer">${
            c.flickCount
          }次  <span class="popup-record-btn">查询记录</span></div>
        </div>
        <div class="left-item">
          <div class="left-name">第一次查询时间戳:</div>
          <div class="left-answer">${c.firstFlickTime}</div>
        </div>
        <div class="left-item">
          <div class="left-name">第一次查询地理戳:</div>
          <div class="left-answer">${c.firstFlickPlace}</div>
        </div>
        {<div class="left-item">
          <div class="left-name">区块链全球唯一编号:</div>
          <div class="left-answer">${c.blockNo == null ? "" : c.blockNo}</div>
        </div>}
        <div class="left-item">
          <div class="left-name">区块链hash:</div>
          <div class="left-answer">${
            c.blockHash == null ? "" : c.blockHash
          }</div>
        </div>
        ${
          c.fakeUrl
            ? c.fakeUrl.includes("http")
              ? `<div class="left-item">
        <div class="left-name">产品身份标识:</div>
        <div class="left-answer"><img src="${c.fakeUrl}" /></div>
      </div>`
              : `<div class="left-item">
            <div class="left-name">产品身份标识:</div>
            <div class="left-answer"><img src="http://file.cjm.so/${c.fakeUrl}" /></div>
          </div>`
            : ""
        }
        
      </div>
      <div class="popup-detail-left">
      ${
        c.productDetail.businessName
          ? `<div class="left-item">
        <div class="left-name right">企业名称:</div>
        <div class="left-answer">${c.productDetail.businessName}</div>
      </div>`
          : ``
      }
        
        ${
          c.organizationAddress
            ? `<div class="left-item">
        <div class="left-name right">地址:</div>
        <div class="left-answer">${c.organizationAddress}</div>
      </div>`
            : ``
        }
      ${
        c.productDetail.productName
          ? `<div class="left-item">
        <div class="left-name right">产品名称:</div>
        <div class="left-answer">${c.productDetail.productName}</div>
      </div>`
          : ``
      }
        
        ${
          c.productDetail.productSpecificationsName
            ? `<div class="left-item">
          <div class="left-name right">产品规格:</div>
          <div class="left-answer">${c.productDetail.productSpecificationsName}</div>
        </div>`
            : ``
        }
        ${
          c.productDetail.productModel
            ? `<div class="left-item">
          <div class="left-name right">产品型号:</div>
          <div class="left-answer">${c.productDetail.productModel}</div>
        </div>`
            : ``
        }
        ${
          c.productDetail.productPrice
            ? `<div class="left-item">
          <div class="left-name right">产品价格:</div>
          <div class="left-answer">${c.productDetail.productPrice}</div>
        </div>`
            : ``
        }
        ${
          c.productDetail.productBatchName
            ? `<div class="left-item">
          <div class="left-name right">产品批次:</div>
          <div class="left-answer">${c.productDetail.productBatchName}</div>
        </div>`
            : ``
        }
        ${
          c.productDetail.productImgUrl
            ? c.productDetail.productImgUrl.includes("http")
              ? `<div class="product-img"><img src="${c.productDetail.productImgUrl}" /></div>`
              : `<div class="product-img"><img src="http://file.cjm.so/${c.productDetail.productImgUrl}" /></div>`
            : ""
        }
      </div>

    </div>
  </div>
    
  </div>
  
  </div>`;
      $(".login1").append(el);
      $(".login1 .popup-record-btn").css("pointer-events", "auto");

      $(".login1 .popup-close").click(function () {
        $(".login1 .popup-wrap").css("display", "none");
      });
      $(".login1 .popup-record-btn").click(async function () {
        $(".login1 .popup-record-btn").css("pointer-events", "none");

        const res2 = await axios.get(
          `${api.common.checkRecord}?version=3.0&fakeCode=${codeHref}`
        );
        // $(".popup-content").css("margin-top", 40);
        var l = res2.data.results;
        var a = "";
        l &&
          l.forEach((item, index) => {
            a += `<div class="list-item" key="${index}">
          <div>${item.createDate}</div>
          <div>${item.fakeCode}</div>
          <div>${item.ipAddress}</div>
          <div>${item.ipPlace}</div>
        </div>`;
          });
        var element = `<div class="popup-list">
                <div class="list-text">查询记录</div>
                <div class="list-box">
                  <div class="list-header">
                    <div>查询时间戳</div>
                    <div>产品身份码</div>
                    <div>IP地址</div>
                    <div>地理戳</div>
                  </div>
                  <div class="list-content">
                  </div>
                </div>
              </div>`;
        $(".popup-content").append(element);
        a != "" ? $(".list-content").html(a) : ``;
      });
    }
  } else {
    // 真伪查询
    $(".login1 .login1-search").click(async function () {
      // $(".login2-wrong").css("display", "none");
      const antikeCode = $("input").val();
      let reg = /^(\d{20}|\d{21}|\d{22})$/;
      if (!reg.test(antikeCode) || !antikeCode) {
        // alert("请输入20位到22位防伪码");
        toastr.info("请输入20位到22位防伪码");
        // $(".login2-wrong").css("display", "block");
      } else {
        const params = {};
        params.fakeCode = antikeCode;
        const res = await axios.get(
          `${api.common.checkout}?fakeCode=${antikeCode}`
        );
        if (res.data.state == 200) {
          let c = res.data.results[0];
          var el = `<div class="popup-wrap">
      <div class="popup-box">
      <div class="popup-close"></div>
      <div class="popup-content">
        <div class="popup-head">
          <div class="popup-head-num">${c.flickCount}</div>
          <div class="popup-head-text">${c.prompt}</div>
        </div>
        <div class="popup-detail">
          <div class="popup-detail-left">
            <div class="left-item">
              <div class="left-name">产品身份编码:</div>
              <div class="left-answer">${c.productDetail.fakeCode}</div>
            </div>
            <div class="left-item">
              <div class="left-name">当前查询次数:</div>
              <div class="left-answer">${
                c.flickCount
              }次  <span class="popup-record-btn">查询记录</span></div>
            </div>
            <div class="left-item">
              <div class="left-name">第一次查询时间戳:</div>
              <div class="left-answer">${c.firstFlickTime}</div>
            </div>
            <div class="left-item">
              <div class="left-name">第一次查询地理戳:</div>
              <div class="left-answer">${c.firstFlickPlace}</div>
            </div>
            <div class="left-item">
              <div class="left-name">区块链全球唯一编号:</div>
              <div class="left-answer">${
                c.blockNo == null ? "" : c.blockNo
              }</div>
            </div>
            <div class="left-item">
              <div class="left-name">区块链hash:</div>
              <div class="left-answer">${
                c.blockHash == null ? "" : c.blockHash
              }</div>
            </div>
            ${
              c.fakeUrl
                ? c.fakeUrl.includes("http")
                  ? `<div class="left-item">
            <div class="left-name">产品身份标识:</div>
            <div class="left-answer"><img src="${c.fakeUrl}" /></div>
          </div>`
                  : `<div class="left-item">
                <div class="left-name">产品身份标识:</div>
                <div class="left-answer"><img src="http://file.cjm.so/${c.fakeUrl}" /></div>
              </div>`
                : ""
            }
            
          </div>
          <div class="popup-detail-left">
          ${
            c.productDetail.businessName
              ? `<div class="left-item">
            <div class="left-name right">企业名称:</div>
            <div class="left-answer">${c.productDetail.businessName}</div>
          </div>`
              : ``
          }
            
            ${
              c.organizationAddress
                ? `<div class="left-item">
            <div class="left-name right">地址:</div>
            <div class="left-answer">${c.organizationAddress}</div>
          </div>`
                : ``
            }
          ${
            c.productDetail.productName
              ? `<div class="left-item">
            <div class="left-name right">产品名称:</div>
            <div class="left-answer">${c.productDetail.productName}</div>
          </div>`
              : ``
          }
            
            ${
              c.productDetail.productSpecificationsName
                ? `<div class="left-item">
              <div class="left-name right">产品规格:</div>
              <div class="left-answer">${c.productDetail.productSpecificationsName}</div>
            </div>`
                : ``
            }
            ${
              c.productDetail.productModel
                ? `<div class="left-item">
              <div class="left-name right">产品型号:</div>
              <div class="left-answer">${c.productDetail.productModel}</div>
            </div>`
                : ``
            }
            ${
              c.productDetail.productPrice
                ? `<div class="left-item">
              <div class="left-name right">产品价格:</div>
              <div class="left-answer">${c.productDetail.productPrice}</div>
            </div>`
                : ``
            }
            ${
              c.productDetail.productBatchName
                ? `<div class="left-item">
              <div class="left-name right">产品批次:</div>
              <div class="left-answer">${c.productDetail.productBatchName}</div>
            </div>`
                : ``
            }
            ${
              c.productDetail.productImgUrl
                ? c.productDetail.productImgUrl.includes("http")
                  ? `<div class="product-img"><img src="${c.productDetail.productImgUrl}" /></div>`
                  : `<div class="product-img"><img src="http://file.cjm.so/${c.productDetail.productImgUrl}" /></div>`
                : ""
            }
          </div>

        </div>
      </div>
        
      </div>
      
      </div>`;
          $(".login1").append(el);
          $(".login1 .popup-record-btn").css("pointer-events", "auto");

          $(".login1 .popup-close").click(function () {
            $(".login1 .popup-wrap").css("display", "none");
          });
          $(".login1 .popup-record-btn").click(async function () {
            $(".login1 .popup-record-btn").css("pointer-events", "none");

            const params2 = {};
            params2.version = 3.0;
            params2.fakeCode = antikeCode;
            const res2 = await axios.get(
              `${api.common.checkRecord}?version=3.0&fakeCode=${antikeCode}`
            );
            // $(".popup-content").css("margin-top", 40);
            var l = res2.data.results;
            var a = "";
            l &&
              l.forEach((item, index) => {
                a += `<div class="list-item" key="${index}">
              <div>${item.createDate}</div>
              <div>${item.fakeCode}</div>
              <div>${item.ipAddress}</div>
              <div>${item.ipPlace}</div>
            </div>`;
              });
            var element = `<div class="popup-list">
                    <div class="list-text">查询记录</div>
                    <div class="list-box">
                      <div class="list-header">
                        <div>查询时间戳</div>
                        <div>产品身份码</div>
                        <div>IP地址</div>
                        <div>地理戳</div>
                      </div>
                      <div class="list-content">
                      </div>
                    </div>
                  </div>`;
            $(".popup-content").append(element);
            a != "" ? $(".list-content").html(a) : ``;
          });
        } else {
          // return alert(res.data.msg);
          return toastr.error(res.data.msg);
        }
      }
    });
  }
});
